import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {FlowState} from "@nolimitcity/slot-game/bin/flowcontrol/FlowState";
import {RockBottom} from "../RockBottom";
import {gsap} from "gsap";
import {IReplayNextPlayerInteraction} from "../server/data/IRockBottomData";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {RockBottomParsedGameData} from "../server/data/RockBottomParsedGameData";
import {RockBottomParsedInitData} from "../server/data/RockBottomParsedInitData";
import {RockBottomGameConfig} from "../RockBottomGameConfig";

export class RBSoftWinCapPresentation implements FlowStatePresentation {
    private _controller: FlowStateController;

    constructor() {
    }

    start(flowStateController: FlowStateController): void {
        this._controller = flowStateController;
        if (this._controller.state === FlowState.IDLE) {
            if (RockBottom.autoPlayPlugin.turnOffAutoplayOnBonus) {
                RockBottom.autoPlayPlugin.turnOffAutoplayOnBonus();
            }
            const parsedGameData: RockBottomParsedGameData | RockBottomParsedInitData = RockBottom.getParsedData(),
                tl: gsap.core.Timeline = RockBottom.pickAndClickView.showView((index: number) => this.pickDone(index), parsedGameData.freespinsLeft, RockBottom.apiPlugin.isReplay),
                nextPlayerInteraction: IReplayNextPlayerInteraction | undefined = RockBottom.model.data.nextPlayerInteraction;

            if (nextPlayerInteraction) {
                if (RockBottom.apiPlugin.isReplay && nextPlayerInteraction.selectedIndex) {
                    tl.add(()=>{
                        RockBottom.pickAndClickView.playToastAnim(RockBottomGameConfig.MID_SYMS[nextPlayerInteraction.selectedIndex]);
                    });
                    tl.add(gsap.to(this, 0.8, {}));
                    tl.add(() => {
                        this.pickDone(nextPlayerInteraction.selectedIndex);
                    });
                }
            }
        } else if (this._controller.state === FlowState.RESULT) {
            const tl: gsap.core.Timeline = gsap.timeline();
            tl.to(this, {duration: 0.8});
            tl.add(() => {
                this._controller.finish();
            });
        }
    }

    private pickDone(index: number): void {
        this._controller.finish();
        SlotGame.apiPlugin.betHandler.pickAndClickBet(index, false);
    }
}